// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3GUfF","requiredAsterisk":"Info_requiredAsterisk__1bfmJ"};